import React from 'react'

import { getTimeZone, mergeStyles } from '@enlyt/base'
import addressToString from 'helpers/addressToString'

import defaultStyles from 'components/Appointments/AppointmentBookingModal/TimeLocation/styles'

const timeSlotOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  weekday: 'long',
  hour: 'numeric',
  minute: 'numeric'
}

const TimeLocation = props => {
  const styles = mergeStyles(defaultStyles, props.style)
  const { selectedTimeslot, locationSelected } = props

  return (
    <>
      <div style={styles.date}>
        {selectedTimeslot.date.toLocaleDateString('en-US', timeSlotOptions)}{' '}
        {getTimeZone(locationSelected.timeZone)}
      </div>
      <div style={styles.address}>
        {addressToString(locationSelected.address)}
      </div>
    </>
  )
}

export default TimeLocation
